import React, { useEffect, useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { Typography, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import LocalActivity from '@material-ui/icons/LocalActivity';
import Input from '@material-ui/core/Input';

import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import InputDate from '~/components/Input/InputDate';
import InputNumber from '~/components/Input/InputNumber';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputReais from '~/components/Input/InputReais';
import Form from '~/containers/Form';

import CouponRecord from '~/records/CouponRecord';
import useStyles from './styles';

const attrName = (attr) => CouponRecord.hummanAttributeName(attr);

function CouponForm({ record, setRecord, handleChange, onSubmit, loading }) {
  const classesRoot = useStyles();
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();

  const [discountState, setDiscountState] = useState({
    showDiscountInput: false,
    textTypeDiscount: '',
    moneyType: false,
    percentType: false
  });

  useEffect(() => {
    if (record?.discount_type === '') return;
    const discountType = record?.discount_type === 1 ? 'money' : 'percent';
    handleDiscountChange(discountType);
  }, [record.discount_type]);
  
  const handleDiscountChange = (discountType) => {
    const discountTypeInt = discountType === 'money' ? 1 : 2;
    setRecord(record.updateAttributes({ discount_type: discountTypeInt }));

    setDiscountState({
      showDiscountInput: true,
      textTypeDiscount: discountType === 'money' ? 'R$' : '%',
      moneyType: discountType === 'money',
      percentType: discountType !== 'money'
    });
  };

  const handleChangeRadioDiscount = (e) => {
    handleDiscountChange(e.target.value, 0);
  };

  return (
    <>
      <Form onSubmit={onSubmit}>
        <Paper
          Icon={LocalActivity}
          iconColor={isPersisted ? 'purple' : 'blue'}
          title={
            isPersisted ? t('coupon.extras.edit') : t('coupon.extras.create')
          }
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem sm={12} md={6}>
                <InputControl
                  name={'name'}
                  value={record.get('name')}
                  label={attrName('name')}
                  required={true}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>

              <GridItem sm={12} md={6}>
                <InputControl
                  value={moment(record.get('start_date')).format()}
                  name="start_date"
                  label={attrName('start_date')}
                  required={true}
                  inputComponent={InputDate}
                  InputProps={{
                    type: 'datetime',
                    isClearable: true,
                    minDate: moment()
                  }}
                  onChange={(date) =>
                    handleChange({ start_date: moment(date).format() })
                  }
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem sm={12} md={6}>
              <InputControl
                  name={'promotion_type'}
                  value={record.get('promotion_type')}
                  label={attrName('promotion_type')}
                  required={true}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>

              <GridItem sm={12} md={6}>
                <InputControl
                  value={moment(record.get('expires_at')).format()}
                  name="expires_at"
                  label={attrName('expires_at')}
                  required={true}
                  inputComponent={InputDate}
                  InputProps={{
                    type: 'datetime',
                    isClearable: true,
                    minDate: moment()
                  }}
                  onChange={(date) =>
                    handleChange({ expires_at: moment(date).format() })
                  }
                />
              </GridItem>

            </GridContainer>

            <GridContainer>
              <GridItem sm={12} md={6}>
                <InputControl
                    name={'user_limit'}
                    value={record.get('user_limit')}
                    label={attrName('user_limit')}
                    required={true}
                    inputComponent={InputNumber}
                    InputProps={{
                      precision: 0,
                      showMask: false
                    }}
                    onChange={ handleChange }
                    autoComplete={false}
                />
              </GridItem>

              <GridItem sm={12} md={5}>
              <span>
                <div style={{ display: 'flex' }}>
                  <Typography
                    style={{
                      fontSize: '13px',
                      color: '#505050',
                      fontWeight: '500',
                    }}
                  >
                    {attrName('discount_type')}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '13px',
                      color: 'red',
                      fontWeight: '500',
                    }}
                  >
                    &nbsp;*
                  </Typography>
                </div>
                <RadioGroup
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                    name="discount_type"
                    value={record.get('discount_type')}
                    aria-label="discount_type"
                    onChange={handleChangeRadioDiscount}
                    row
                  >
                    <FormControlLabel
                      value={'percent'}
                      control={
                        <Radio 
                          checked={discountState.percentType}
                          required={true}
                          size="small" 
                          color="primary"
                        />
                      }
                      label="Porcentagem"
                    />
                    <FormControlLabel
                      value={'money'}
                      control={
                        <Radio 
                          checked={discountState.moneyType}
                          size="small" 
                          color="primary"
                        />
                      }
                      label="Real"
                    />
                  </RadioGroup>
                </span>
              </GridItem>
              
            </GridContainer>

            <GridContainer style={{marginTop: -50, marginLeft: -50}}>

            <GridItem sm={12} md={6}>
            </GridItem>
            
            <GridItem sm={12} md={6}>
                {discountState.showDiscountInput && (
                  <GridContainer>
                    <GridItem sm={2} md={2}>
                      <Typography
                          style={{
                            fontSize: '26px',
                            color: '#505050',
                            paddingTop: '10px',
                            paddingLeft: '3.5vw'
                          }}
                        >
                        {discountState.textTypeDiscount}
                      </Typography>
                    </GridItem>
                    <GridItem sm={10} md={10}>
                    {discountState.showDiscountInput && (
                      <InputControl
                          name={'discount_value'}
                          value={record.get('discount_value')}
                          label={attrName('')}
                          inputComponent={InputReais}
                          onChange={ handleChange }
                          autoComplete={false}
                      />
                    )}
                    </GridItem>
                  </GridContainer>
                )}
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

CouponForm.propTypes = {
  record: PropTypes.instanceOf(CouponRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

CouponForm.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(CouponForm));
